// extracted by mini-css-extract-plugin
export default {"successButton":"success_successButton__2puPk"};